import React from 'react';
import { cn } from '../utils/classUtils';
import { formatCurrency } from '../utils/currencyUtils';

export interface FeeItem {
  label: string;
  amount: number;
  currency?: string;
  isDiscount?: boolean;
}

export interface OneTimeFeeCardProps {
  items: FeeItem[];
  subtotal: number;
}

const OneTimeFeeCard: React.FC<OneTimeFeeCardProps> = ({ items, subtotal }) => {
  return (
    <div className={cn('bg-reskin-primary-blue p-0.5 rounded-2xl')}>
      <div className='text-white text-center py-1'>
        <h3 className='text-xs font-inter-semibold'>One-Time Fee</h3>
      </div>

      <div className='bg-white rounded-[14px] p-5'>
        <div className='flex flex-col gap-3'>
          {items.map((item) => (
            <div
              key={item.label}
              className='flex justify-between items-center gap-3'
            >
              <span className='text-xs font-inter text-neutral-800 leading-[18px] flex-1 break-all sm:break-normal'>
                {item.label}
              </span>
              <span
                className={cn(
                  'text-sm font-inter-semibold leading-5 whitespace-nowrap',
                  item.isDiscount
                    ? 'text-reskin-green-600'
                    : 'text-neutral-800',
                )}
              >
                {formatCurrency(item.amount, item.isDiscount, item.currency)}
              </span>
            </div>
          ))}

          <div className='h-px bg-reskin-regent-300 w-full' />

          <div className='flex flex-col gap-1'>
            <div className='flex justify-between items-center'>
              <span className='text-sm font-inter-bold text-neutral-800'>
                Total
              </span>
              <span className='text-sm font-inter-bold text-neutral-800 whitespace-nowrap'>
                {formatCurrency(subtotal, false, items[0].currency)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneTimeFeeCard;
